import {useState} from 'react';
import ProfileTab from "./Tabs/ProfileTab";
import {makeStyles, Tabs, Box, Tab, useTheme} from "@material-ui/core";
import PropTypes from "prop-types";
import {IoIosClose} from "react-icons/io";
import AddressTab from "./Tabs/AddressTab";
import CartTab from "./Tabs/CartTab";
import TodoTab from "./Tabs/TodoTab";
import SubscriptionsTab from "./Tabs/SubscriptionsTab";
import PreferencesTab from "./Tabs/PreferencesTab";
import LikesTab from "./Tabs/LikesTab";
import SharesTab from "./Tabs/SharesTab";
import ViewsTab from "./Tabs/ViewsTab";
import ReferAndEarnTab from "./Tabs/ReferAndEarnTab";
import CouponsTab from "./Tabs/CouponsTab";
import {useSelector} from "react-redux";
import EldSubscriptionsTab from "./Tabs/EldSubscriptionsTab";
import EldFamilyMembersTab from "./Tabs/EldFamilyMembersTab";
import EldResidencesTab from "./Tabs/EldResidencesTab";

function getModalStyle() {
    const top = 50
    const left = 50

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}


const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#6CD7BB"
    }
}))

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            style={{backgroundColor: "white"}}
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <p>{children}</p>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function MemberProfileDetailsModal({clickedElder, handleCloseModal, setClickedSubscription, handleOpenSubscriptionModal}) {
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [modalStyle] = useState(getModalStyle);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChange1 = (event, newValue) => {
        setValue(newValue);
    };
    const classes = useStyles();
    const customer_data = useSelector(state =>
        state?.customers?.users?.find(item => item.userId == clickedElder.id)
    );

    return (
        clickedElder &&
        <div style={modalStyle} className={'modal-paper'}>
            <div className={'modal-top-bar'}>
                <IoIosClose
                    size={20}
                    className={'modal-close'}
                    onClick={handleCloseModal}
                />
            </div>

            <div style={{margin: "0 0 10px 0"}}>
                <h5>Elder: {clickedElder.id}</h5>
                <div style={{display: 'flex', marginTop: 10}}>
                    <p style={{marginRight: 20}}>Customer: {(clickedElder.user_id)?clickedElder.user_id:''}</p>
                    <p style={{marginRight: 20}}>Name: {(clickedElder.name)?clickedElder.name:customer_data?.firstName+' '+customer_data?.lastName}</p>
                    <p style={{marginRight: 20}}>Mobile: {(clickedElder.dob)?clickedElder.mobile:customer_data?.mobile}</p>
                    <p>DOB: {(clickedElder.dob)?clickedElder.dob:customer_data?.dob}</p>
                </div>
            </div>


            <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="on"
                classes={{
                    indicator: classes.indicator
                }}>
                <Tab label="24X7 Subscriptions" {...a11yProps(0)} />
                <Tab label="Member Home"
                     style={{}} {...a11yProps(1)} />
                <Tab label="Family Members"
                     {...a11yProps(2)} />
                {/* <Tab label="LifeStyle Membership"
                     {...a11yProps(3)} />
                <Tab label="LifeStyle Activities"
                     {...a11yProps(4)} /> */}
            </Tabs>
            <div className={'modal-body'}>
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <EldSubscriptionsTab clickedElder={clickedElder} />
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    <EldResidencesTab  clickedElder={clickedElder}/>
                </TabPanel>
                <TabPanel value={value} index={2} dir={theme.direction}>
                    <EldFamilyMembersTab clickedElder={clickedElder}/>
                </TabPanel>
                {/* <TabPanel value={value} index={3} dir={theme.direction}>
                    <h1>LifeStyle Membership</h1>
                </TabPanel>
                <TabPanel value={value} index={4} dir={theme.direction}>
                    <h1>LifeStyle Activities</h1>
                </TabPanel> */}
            </div>
        </div>
    );
}

export default MemberProfileDetailsModal;
